export const ERoutes = {
  BOOKING: "/booking",
  PARTY: "/party",
  PURCHASE: "/purchase",
  LUBE_SALE: "/lubeSale",
  CARDS: "/cards",
  CREDITS: "/credits",
  RECEIPT: "/receipts",
  PAYMENT: "/payment",
  JV: "/journalVoucher",
  DAILYSHEET: "/dailySheet",
  EVENT_REPORT: "/eventReport",
  BULK_PURCHASE: "/bulkPurchase",
  VEHICAL: "/createVehical",
  BANK: "/bankVoucher",
  EXPENSE: "/expenseVoucher",
  PETTY_EXPENSE: "/pettyExpenseVoucher",
  DAYBOOK: "/daybook",
  PLEDGER: "/PLedger",
  CACCOUNT: "/chartOfAccount",
  GLEDGER: "/GLedger"

};
